import React, { useState, useEffect } from 'react'
import { PostData } from '../Services/httpHandelars'
import Snackbar from '../Components/Snackbar';

export default function ChangePassword() {

    const [form, setForm] = useState({ old_password: '', new_password: '', confirm_password: ''});
    const [snacBar, setSnacBar] = useState({ snacStatus: false, message: "", snackType: "" });
    const [showPassword, setShowPassword] = useState(false) 
    const [showNewPassword, setShowNewPassword] = useState(false) 
    const [showNewConfrimPassword, setShowNewConfrimPassword] = useState(false) 

    useEffect(
        () => {
          if (snacBar.snacStatus === true) {
            setTimeout(() => setSnacBar(false), 3000);
          }
        },
    
        [snacBar.snacStatus]
    );

    const handleChange = (event) => {
        setForm({ ...form, [event.target.name]: event.target.value });
    };

    const handleClickShowPassword = () =>{
        setShowPassword(showPassword => !showPassword)
      }

    const handleClickShowNewPassword = () =>{
        setShowNewPassword(showNewPassword => !showNewPassword)
      }

    const handleClickShowNewConfirmPassword = () =>{
        setShowNewConfrimPassword(showNewConfrimPassword => !showNewConfrimPassword)
      }

    const validatePassword = (pass) => {
        const reg = /(?=^.{8,16}$)(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?!.*\s)[0-9a-zA-Z!*^?](?=.*[+-_@#$%&])/
        return reg.test(pass)
    }

    const handleSubmit = (e) => {
        e.preventDefault();

        if (!form.new_password && !form.confirm_password && !form.old_password) {
            setSnacBar({
                ...snacBar,
                snacStatus: true,
                message: "Kindly fill all the fields",
                snackType: "Error"
            })
            return
        }

        if (form.new_password.length >= 8 && form.confirm_password.length >= 8) {
            if (validatePassword(form.new_password) && validatePassword(form.confirm_password)) {
                if (form.new_password === form.confirm_password) {
                    const data = {
                        oldPassword: form.old_password,
                        newPassword: form.new_password,
                    }
                    PostData("/api/user/changePassword", data).then((success) => {
                        console.log(success, "---------success")
                        if(success.status === true) {
                            setSnacBar({
                                ...snacBar,
                                snacStatus: success.status,
                                message: success.message,
                                snackType: "Success"
                            })
                            setForm({ ...form, old_password: '', new_password: '', confirm_password: '' })
                        } else {
                            console.log("else block!!!")
                            setSnacBar({
                              ...snacBar,
                              snacStatus: true,
                              message: success.message,
                              snackType: "Error"
                            })
                          }
                    })
                }
                else {
                    setSnacBar({
                        ...snacBar,
                        snacStatus: true,
                        message: "Password does not match",
                        snackType: "Error"
                    })
                }
            } else {
                setSnacBar({
                    ...snacBar,
                    snacStatus: true,
                    message: "Invalid password",
                    snackType: "Error"
                })
            }
        } else {
            setSnacBar({
                ...snacBar,
                snacStatus: true,
                message: "Password must be more than or is equals to 8 characters",
                snackType: "Error"
            })
        }
    }

    return (
        <>
        <div className="flex justify-center mt-28">
            <div className="block p-6 rounded-lg shadow-lg bg-white w-1/5">
                <h5 className="text-gray-900 text-xl leading-tight font-medium mb-2 text-center">Change Password</h5>
                <div className=" mb-4 mt-8">
                    <label className="block text-gray-700 text-sm font-bold mb-2" for="username">
                        Old Password
                    </label>
                    <div className='relative flex w-full justify-end '>
                    <input
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                        id="username"
                        type= {showPassword ?  "text" : "password" }
                        name='old_password'
                        value={form.old_password}
                        onChange={handleChange}
                    />
                        {showPassword ? (
                  <span onClick={handleClickShowPassword} className="absolute -top-0 bottom-0 flex flex-col  justify-center items-end ">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className=" mr-2 w-6 h-6">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M2.036 12.322a1.012 1.012 0 010-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178z" />
                      <path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                    </svg>

                  </span>
                  ) : (
                    <span onClick={handleClickShowPassword} className="absolute -top-0 bottom-0 flex flex-col  justify-center items-end ">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className=" mr-2 w-6 h-6">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M3.98 8.223A10.477 10.477 0 001.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.45 10.45 0 0112 4.5c4.756 0 8.773 3.162 10.065 7.498a10.523 10.523 0 01-4.293 5.774M6.228 6.228L3 3m3.228 3.228l3.65 3.65m7.894 7.894L21 21m-3.228-3.228l-3.65-3.65m0 0a3 3 0 10-4.243-4.243m4.242 4.242L9.88 9.88" />
                    </svg>

                  </span>

                  )} 
                  </div>
                </div>

                <div className="mb-4 mt-8">
                    <label className="block text-gray-700 text-sm font-bold mb-2" for="username">
                        New Password
                    </label>
                    <div className='relative flex w-full justify-end '>
                    <input
                        onChange={handleChange}
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                        id="username"
                        type= {showNewPassword ?  "text" : "password" }
                        name='new_password'
                        value={form.new_password}
                    />
                        {showNewPassword ? (
                  <span onClick={handleClickShowNewPassword} className="absolute -top-0 bottom-0 flex flex-col  justify-center items-end ">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className=" mr-2 w-6 h-6">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M2.036 12.322a1.012 1.012 0 010-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178z" />
                      <path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                    </svg>

                  </span>
                  ) : (
                    <span onClick={handleClickShowNewPassword} className="absolute -top-0 bottom-0 flex flex-col  justify-center items-end ">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className=" mr-2 w-6 h-6">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M3.98 8.223A10.477 10.477 0 001.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.45 10.45 0 0112 4.5c4.756 0 8.773 3.162 10.065 7.498a10.523 10.523 0 01-4.293 5.774M6.228 6.228L3 3m3.228 3.228l3.65 3.65m7.894 7.894L21 21m-3.228-3.228l-3.65-3.65m0 0a3 3 0 10-4.243-4.243m4.242 4.242L9.88 9.88" />
                    </svg>

                  </span>

                  )} 

                    </div>
                </div>

                <div className="mb-4 mt-8">
                    <label className="block text-gray-700 text-sm font-bold mb-2" for="username">
                        Confirm Password
                    </label>
                    <div className='relative flex w-full justify-end '>
                    <input
                        onChange={handleChange}
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                        id="username"
                        type= {showNewConfrimPassword ?  "text" : "password" }
                        name='confirm_password'
                        value={form.confirm_password}
                    />
                    {showNewConfrimPassword ? (
                  <span onClick={handleClickShowNewConfirmPassword} className="absolute -top-0 bottom-0 flex flex-col  justify-center items-end ">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="mr-2 w-6 h-6">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M2.036 12.322a1.012 1.012 0 010-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178z" />
                      <path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                    </svg>

                  </span>
                  ) : (
                    <span onClick={handleClickShowNewConfirmPassword} className="absolute -top-0 bottom-0 flex flex-col  justify-center items-end ">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="mr-2 w-6 h-6">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M3.98 8.223A10.477 10.477 0 001.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.45 10.45 0 0112 4.5c4.756 0 8.773 3.162 10.065 7.498a10.523 10.523 0 01-4.293 5.774M6.228 6.228L3 3m3.228 3.228l3.65 3.65m7.894 7.894L21 21m-3.228-3.228l-3.65-3.65m0 0a3 3 0 10-4.243-4.243m4.242 4.242L9.88 9.88" />
                    </svg>

                  </span>

                  )} 
                </div>


                </div>

                <div>
                    <button
                        onClick={handleSubmit}
                        type="button"
                        className="inline-block w-full py-2.5 bg-green-600 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-green-700 hover:shadow-lg focus:bg-green-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-green-800 active:shadow-lg transition duration-150 ease-in-out">Change Password</button>
                </div>

        {snacBar?.snacStatus &&
            <Snackbar snackType={snacBar?.snackType} message={snacBar.message} status={true}/>
        }
            </div>
        </div>

    </>
    )
}
